import { cva } from 'class-variance-authority';

export const cvaFoot = cva([
  'footer-styles-cvaFoot',
  'bg-black rounded-t-[32px] text-base relative pb-[227px]',
  "after:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-[227px]",
  "after:bg-[url('/static/i/main_pattern.webp')] after:bg-left-bottom after:bg-repeat-x after:bg-[length:1360px] after:opacity-40",
  'semiMd-max:pb-[113px] semiMd-max:after:h-[113px] semiMd-max:after:bg-[length:680px]',
]);

export const cvaFootInner = cva([
  'footer-styles-cvaFootInner',
  'mx-auto max-w-[1134px] px-5 pt-20 pb-[50px] text-general_text_MII_secondary_i flex gap-2.5 justify-between',
  'sm-max:flex-col sm-max:gap-5 sm-max:pt-[60px]',
]);

export const cvaFootTitle = cva([
  'footer-styles-cvaFootTitle',
  'max-w-[380px] -mt-[17px] font-bold text-[34px] leading-normal text-white font-raleway',
]);

export const cvaFootBtn = cva([
  'footer-styles-cvaFootBtn',
  'inline-flex items-center justify-center cursor-pointer transition-all duration-300',
  'bg-general_MI_500_default text-white rounded-full hover:bg-secondary_success_SI_600_success',
  'px-[55px] py-[15px] text-xl mt-[15px]',
]);

export const cvaFootLink = cva([
  'footer-styles-cvaFootLink',
  'text-general_MI_500_default cursor-pointer flex items-center hover:text-secondary_success_SI_600_success',
  'text-xl sm-max:text-lg',
]);

export const cvaFootBlock2 = cva([
  'footer-styles-cvaFootBlock2',
  'flex flex-col gap-[15px] -mt-[3px]',
]);

export const cvaFootBlock3 = cva(['footer-styles-cvaFootBlock3', 'flex flex-col gap-[17px]']);

export const cvaFootSocial = cva(['footer-styles-cvaFootSocial', 'mt-[5px] flex gap-2.5']);

export const cvaFootLegal = cva(['footer-styles-cvaFootLegal', 'text-sm flex items-center']);

export const cvaFootLegalLink = cva([
  'footer-styles-cvaFootLegalLink',
  'text-general_MI_500_default cursor-pointer flex items-center hover:text-secondary_success_SI_600_success',
]);

export const cvaFootLegalSeparator = cva([
  'footer-styles-cvaFootLegalSeparator',
  'mx-2.5 text-general_MI_500_default',
]);

export const cvaFootSupportLink = cva([
  'footer-styles-cvaFootSupportLink',
  'text-general_MI_500_default cursor-pointer flex items-center hover:text-secondary_success_SI_600_success',
]);
